import { noop } from 'lodash';
import { createContext, Dispatch, SetStateAction, useContext } from 'react';
import { CampaignFilterDefaults } from '../constants';
import { CampaignFilters, ParsedMediumMetric, ParsedOverallMetric } from '../types';

type CampaignAndMetricFiltersContextState = {
  filteredHLMDefaults: string[];
  campaignFilters: CampaignFilters;
  setCampaignFilters: Dispatch<SetStateAction<CampaignFilters>>;
  selectedCrossMetrics: string[];
  setSelectedCrossMetrics: (selectedCrossMetrics: string[]) => void;
  mediumMetrics: ParsedMediumMetric[];
  overallMetrics: ParsedOverallMetric[];
  selectedMediums: string[];
  setSelectedMediums: (selectedMediums: string[]) => void;
  appliedCampaignFilters: CampaignFilters;
  setAppliedCampaignFilters: (appliedCampaignFilters: CampaignFilters) => void;
  MediumFilteredHLMs: Set<string>;
  MediumFilteredAMs: Set<string>;
  setPreviousCampaignTableFilters: (vals: string) => void;
  previousCampaignTableFilters: string;
  setPreviousAudienceFilters: (vals: string) => void;
  previousAudienceFilters: string;
  isFiltersInitialized: boolean;
};

export const defaultCampaignAndMetricFiltersState = {
  filteredHLMDefaults: [],
  campaignFilters: CampaignFilterDefaults,
  setCampaignFilters: noop,
  appliedCampaignFilters: CampaignFilterDefaults,
  setAppliedCampaignFilters: noop,
  selectedCrossMetrics: [],
  setSelectedCrossMetrics: noop,
  mediumMetrics: [],
  overallMetrics: [],
  selectedMediums: [],
  setSelectedMediums: noop,
  MediumFilteredHLMs: new Set([]),
  MediumFilteredAMs: new Set([]),
  previousCampaignTableFilters: '',
  setPreviousCampaignTableFilters: noop,
  previousAudienceFilters: '',
  setPreviousAudienceFilters: noop,
  isFiltersInitialized: false,
};

export const CampaignAndMetricFiltersContext = createContext<CampaignAndMetricFiltersContextState>(
  defaultCampaignAndMetricFiltersState,
);

export const useCampaignAndMetricFiltersContext = () => useContext(CampaignAndMetricFiltersContext);
